import { Row, SvgImage } from '@components'
import { StyleTypography } from '@components/styles'
import { Constant } from '@utils/index'
import { formatDistanceToNowStrict } from 'date-fns'
import { StyleInfoContentWrapper } from '../style'

const NotificationOrderInfo = ({ item }: any) => {
  const formattedTime = formatDistanceToNowStrict(new Date(item?.createdAt), {
    addSuffix: true,
    locale: Constant.shortLocale,
  })

  return (
    <Row styleRow={{ columnGap: 10 }}>
      <SvgImage
        src={'notificationBook'}
        width={40}
        height={40}
        color="primary"
      />

      <StyleInfoContentWrapper>
        <StyleTypography spanColor="blue300">{item?.body}</StyleTypography>

        <Row
          styleRow={{
            columnGap: 5,
            marginTop: 'auto',
            justifyContent: 'end',
          }}
        >
          <StyleTypography color="text200">{formattedTime}</StyleTypography>
        </Row>
      </StyleInfoContentWrapper>
    </Row>
  )
}

export default NotificationOrderInfo
